import React, { Fragment, useEffect, useState } from 'react';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import PageSEO from '../Common/PageSEO';
import {
    FeatureHero,
    FeatureCtaButton,
    FeatureListGrid,
    FeatureSection,
    FeatureCta
} from '../Common/FeatureContent';
import { useLocale } from '../../localization/LocaleContext';
import { ROUTE_PATHS } from '../../localization/constants';
import './resourcePages.css';

const CATEGORY_ICONS = [
    (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
    ),
    (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="4" y1="21" x2="4" y2="14"/>
            <line x1="4" y1="10" x2="4" y2="3"/>
            <line x1="12" y1="21" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12" y2="3"/>
            <line x1="20" y1="21" x2="20" y2="16"/>
            <line x1="20" y1="12" x2="20" y2="3"/>
            <line x1="1" y1="14" x2="7" y2="14"/>
            <line x1="9" y1="8" x2="15" y2="8"/>
            <line x1="17" y1="16" x2="23" y2="16"/>
        </svg>
    ),
    (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5"/>
        </svg>
    )
];

function TemplatesMain(){
    const { t, toLocalizedPath, locale } = useLocale();
    const p = (key) => t(`resourcePages.templates.${key}`);

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) {
        return <Loader/>;
    }

    const categories = ['Invoices', 'Quotes', 'Receipts'].map((key, idx) => ({
        icon: CATEGORY_ICONS[idx],
        title: p(`category${key}Title`),
        description: p(`category${key}Description`)
    }));

    const customizeItems = [1, 2, 3, 4].map((num) => p(`customizeList${num}`));

    return(
        <Fragment>
            <PageSEO title={p('metaTitle')} description={p('metaDescription')} path={ROUTE_PATHS.templates} locale={locale} />

            <FeatureHero
                eyebrow={p('eyebrow')}
                title={p('heroTitle')}
                highlight={p('heroHighlight')}
                subtitle={p('heroSubtitle')}
                cta={<FeatureCtaButton to={toLocalizedPath('invoiceGenerator')}>{p('heroCta')}</FeatureCtaButton>}
            />

            <FeatureSection alt title={p('categoriesSectionTitle')} description={p('categoriesSectionDescription')}>
                <div className="rp-card-grid rp-card-grid-3">
                    {categories.map((cat, idx) => (
                        <div className="rp-card" key={idx}>
                            <div className="rp-card-icon">{cat.icon}</div>
                            <h3 className="rp-card-title">{cat.title}</h3>
                            <p className="rp-card-description">{cat.description}</p>
                        </div>
                    ))}
                </div>
            </FeatureSection>

            <FeatureSection title={p('customizeSectionTitle')} description={p('customizeSectionDescription')}>
                <FeatureListGrid items={customizeItems} />
            </FeatureSection>

            <FeatureCta
                title={p('ctaTitle')}
                description={p('ctaDescription')}
                ctaTo={toLocalizedPath('invoiceGenerator')}
                ctaLabel={p('ctaButton')}
            />

            <Footer/>
        </Fragment>
    );
}

export default TemplatesMain;
